// extracted by mini-css-extract-plugin
module.exports = {"drawerCollapsed":"style_drawerCollapsed__OXRmQ","drawerExpanded":"style_drawerExpanded__3D3jL"};